import { setProp } from 'Store/Actions';

export const prefillRegistrationForm = (onboardingUserData: any, dispatch: any, authEmail?: string) => {
    if (!onboardingUserData) return;

    const name = onboardingUserData.name || '';
    const nameParts = name.split(' ');
    const firstName = nameParts[0] || '';
    const lastName = nameParts.slice(1).join(' ') || '';
    const email = authEmail || onboardingUserData.email || '';
    const contactRole = onboardingUserData.role?.contact_role || '';
    
    const phoneNumber = onboardingUserData.role?.phone_number || '';
    const phoneParts = phoneNumber.split('-');
    const phoneCode = phoneParts[0] || null;
    const phoneNumberOnly = phoneParts.slice(1).join('') || '';

    const accountInfo = onboardingUserData.account_info?.[0] || {};
    
    dispatch(setProp({
        slice: 'onboarding',
        key: 'registrationForm',
        value: {
            firstName,
            lastName,
            contactRole,
            email,
            phoneCode: phoneCode,
            phoneNumber: phoneNumberOnly,
            companyName: accountInfo.name || '',
            companyWebsite: accountInfo.website || '',
            companyIndustry: accountInfo.industry || '',
            companyVATNumber: accountInfo.vat_number || '',
            sixStarNumber: accountInfo.six_star_number || '',
            accountOnboardingStatus: accountInfo.account_onboarding_status || '',
            accountNumber: accountInfo.accountnumber || '',
            billingCountry: accountInfo.billingaddress_country || '',
            billingStreet: accountInfo.billingaddress_street || '',
            billingCity: accountInfo.billingaddress_city || '',
            billingState: accountInfo.billingaddress_state || '',
            billingZipCode: accountInfo.billingaddress_postalcode || '',
            shippingCountry: accountInfo.shippingcountry || '',
            shippingStreet: accountInfo.shippingstreet || '',
            shippingCity: accountInfo.shippingcity || '',
            shippingState: accountInfo.shippingstate || '',
            shippingZipCode: accountInfo.shippingpostalcode || '',
        }
    }));
};